export default __webpack_public_path__ + "static/media/4 Advantages - Speed.31d3e172.png";